import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import PaymentForm from './PaymentForm';

const CheckoutModal = ({ 
  isOpen, 
  onClose, 
  plan, 
  stripe, 
  onSuccess, 
  onError,
  actionType = 'new' // 'new', 'upgrade', 'downgrade'
}) => {
  if (!isOpen) return null;

  const getModalTitle = () => {
    switch (actionType) {
      case 'upgrade':
        return `Upgrade to ${plan.name}`;
      case 'downgrade':
        return `Change to ${plan.name}`;
      default:
        return `Subscribe to ${plan.name}`;
    }
  };

  const getModalDescription = () => {
    switch (actionType) {
      case 'upgrade':
        return 'Upgrade your subscription to access more features and storage.';
      case 'downgrade':
        return 'Change your subscription plan. This will take effect at your next billing cycle.';
      default:
        return 'Complete your subscription to start using our services.';
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          onClick={onClose}
        ></div>

        {/* Modal panel */}
        <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {getModalTitle()}
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                {getModalDescription()}
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Plan summary */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="flex justify-between items-center">
              <div>
                <h4 className="font-medium text-gray-900">{plan.name}</h4>
                <p className="text-sm text-gray-600">{plan.description}</p>
              </div>
              <div className="text-right">
                {plan.price && plan.price.amount > 0 ? (
                  <div className="text-lg font-semibold text-gray-900">
                    ${Number(plan.price.amount).toFixed(2)}
                  </div>
                ) : (
                  <div className="text-lg font-semibold text-green-600">Free</div>
                )}
                <div className="text-sm text-gray-600">per month</div>
              </div>
            </div>
          </div>

          {/* Payment form */}
          {stripe && (
            <Elements stripe={stripe}>
              <PaymentForm
                plan={plan}
                actionType={actionType}
                onSuccess={onSuccess}
                onError={onError}
                onCancel={onClose}
              />
            </Elements>
          )}

          {!stripe && (
            <div className="text-center py-8">
              <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-gray-600">Initializing payment system...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckoutModal;
